<template>
  <v-form ref="form" class="access-form" @submit.prevent="submit">
    <div class="access-form__grid">
      <rmr-text-field
        v-model="formData.name"
        label="Nom"
        :rules="[required]"
      />
      <rmr-text-field
        v-model="formData.description"
        label="Description"
        :rules="[required]"
      />
      <rmr-text-field
        v-model="formData.subject"
        label="Subject"
        :rules="[required]"
      />
      <rmr-select
        v-model="formData.action"
        :items="actionsList"
        label="Action"
        :rules="[required]"
      />
    </div>

    <div class="access-form__actions">
      <rmr-action-button
        label="Annuler"
        variant="ghost"
        @click="$emit('cancel')"
      />
      <rmr-action-button
        :label="editing ? `Mettre à jour` : `Créer la permission`"
        :loading="saving"
        type="submit"
      />
    </div>
  </v-form>
</template>

<script>
import { required } from "@core/utils/validation";
import RmrActionButton from "@/components/ui/actions/RmrActionButton.vue";
import RmrSelect from "@/components/ui/forms/RmrSelect.vue";
import RmrTextField from "@/components/ui/forms/RmrTextField.vue";

function buildInitialState(value) {
  return {
    id: value?.id || null,
    name: value?.name || "",
    subject: value?.subject || "",
    action: value?.action || "manage",
    description: value?.description || "",
  };
}

export default {
  name: "PermissionForm",
  components: {
    RmrActionButton,
    RmrSelect,
    RmrTextField,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      actionsList: ["read", "manage", "no_action"],
      formData: buildInitialState(this.value),
    };
  },
  computed: {
    editing() {
      return Boolean(this.value && this.value.id);
    },
  },
  watch: {
    value: {
      deep: true,
      handler(nextValue) {
        this.formData = buildInitialState(nextValue);
        this.$nextTick(() => this.$refs.form?.resetValidation());
      },
    },
    "formData.subject": "syncGeneratedLabels",
    "formData.action": "syncGeneratedLabels",
  },
  methods: {
    capitalizeFirstLetters(str) {
      return str
        .split(" ")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    syncGeneratedLabels() {
      const generated = this.capitalizeFirstLetters(
        `${this.formData.subject} ${this.formData.action}`
      );

      if (!this.editing || !this.formData.name) {
        this.formData.name = generated;
      }

      if (!this.editing || !this.formData.description) {
        this.formData.description = generated;
      }
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit("save", {
        name: this.formData.name,
        subject: this.formData.subject,
        action: this.formData.action,
        description: this.formData.description,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.access-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.access-form__grid {
  display: grid;
  gap: 16px;
}

.access-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 680px) {
  .access-form__actions {
    flex-direction: column-reverse;
  }
}
</style>
